module.exports = __webpack_public_path__ + "static/media/home-product-1.bea07691.png";